export default {
  SET_FIELD_SECURITY_CATEGORY: 'setFieldScurityCategory',
  SET_SELECTED_SECURITY_MARK: 'setSelectedSecurityMark',
  SET_SELECTED_PARENT_MARK: 'setSelectedParentMark'
}